<template>
    <form>
        <b-modal :active.sync="isComponentModalActive"
                 has-modal-card full-screen >

            <div class="modal-card ">
                <section class="modal-card-body"  >

                    <b-tabs v-model="activeTab">
                        <b-tab-item :visible="visibleListTemplate" label="List of Template">
                            <b-button icon-left="plus" type="is-success" @click="addEditTemplate('i',null)">Add New</b-button>
                            <hr>
                            <b-table
                                    :data="isEmpty ? [] : mytemplateModifier"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                                    mobile-cards>


<!--                                    <b-table-column  label="ID" >-->
<!--                                        {{ props.row.id }}-->
<!--                                    </b-table-column>-->

                                    <b-table-column  label="Edit" v-slot="props" >
                                        <b-button icon-left="pencil" type="is-warning" @click="editTemplate('u',props.row.id)">Edit</b-button>
                                    </b-table-column>
                                    <b-table-column  label="Title" v-slot="props">
                                        {{ props.row.title }}
                                    </b-table-column>
                                    <b-table-column  label="Content" v-slot="props">
                                        {{ props.row.content_txt }}
                                    </b-table-column>
                                    <b-table-column  label="Delete" v-slot="props">
                                        <b-button icon-left="delete" type="is-danger" @click="deleteTemplate(props.row.id)">Delete</b-button>
                                    </b-table-column>



                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                        icon="emoticon-sad"
                                                        size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>
                        </b-tab-item>
                        <b-tab-item :visible="visibleAddEditTemplate" label="Add/Edit">


                            <nav class="level is-mobile"  >
                                <div class="level-left">
                                    <div class="level-item">
                                        <b-button type="is-info" @click="displayPage(0)">Back</b-button>
                                    </div>
                                </div>

                                <div class="level-right">
                                    <div class="level-item">
                                        <b-button type="is-success" @click="displayPage(0)">Save</b-button>
                                    </div>
                                </div>
                            </nav>


                            <h1 class="subtitle" >Title Name</h1>
                            <b-input type="text" v-model="bufferTemplateName"  ></b-input>
                            <hr>
                            <h1 class="subtitle" >Content Boby</h1>
                            <vue-editor v-model="bufferTemplateContent"   />
                        </b-tab-item>

                    </b-tabs>
                </section>
                <footer class="modal-card-foot">
                    <b-button size="is-medium" type="is-danger"
                              icon-left="close" @click="close"  >
                        Close
                    </b-button>
                </footer>
            </div>
        </b-modal>
        <AddEditTemplate  v-if="isModalAddEditActive"
                          @close="closeAddEdit"
                          @closeAddEditModalWithChange="closeAddEditModalWithChange"
                          :paramAddEditTemplate=paramAddEditTemplate />
    </form>
</template>

<script>
    /* eslint-disable no-console */
    import {getMyTemplate , getBaseURLforBackEnd , getConfigAxios }  from '@/utils.js'
    import AddEditTemplate from "./AddEditTemplate";
    import {mapState} from "vuex";
    import axios from "axios";
    export default {
        name: "ManageMyTemplate",
        components:{
            AddEditTemplate
        },

        computed:{
            ...mapState({
                user_id : state => state.master_data.user_id,
                clientIP : state => state.master_data.clientIP,
                access_token: state => state.master_data.access_token,
            }),
            mytemplateModifier:function () {
                 return this.mytemplate.map((member)=>{
                     var tmp = ''
                     if (member.content_txt.length>100) {
                        tmp = member.content_txt.substring(0, 100)+'  ...'
                     }else{
                        tmp = member.content_txt
                     }
                     return {
                         "id": member.id,
                         "title": member.title,
                         "content_txt": tmp
                     }
                 })
            }
        },
        data(){
            return {
                isComponentModalActive : false,
                activeTab : 0,
                isEmpty: false,
                mytemplate : [],
                visibleListTemplate: true,
                visibleAddEditTemplate: false,
                // for edit
                bufferTemplateName : "",
                bufferTemplateContent : "",
                //
                isModalAddEditActive : false,
                paramAddEditTemplate :{ mode: "",id: ""} // mode i === insert , u === update
            }
        },
        methods:{

            closeAddEditModalWithChange(){
                this.loadMytemplate()
                this.isModalAddEditActive = false
            },
            closeAddEdit(){
                this.isModalAddEditActive = false
            },
            addEditTemplate(_mode,_id){
                this.paramAddEditTemplate.mode =_mode
                this.paramAddEditTemplate.id= _id
                this.isModalAddEditActive = true

            },
            displayPage(pageIndex){
                if (pageIndex === 0){
                    this.visibleListTemplate = true
                    this.visibleAddEditTemplate =  false
                    this.activeTab = pageIndex
                }
                if (pageIndex === 1){
                    this.visibleListTemplate = false
                    this.visibleAddEditTemplate =  true
                    this.activeTab = pageIndex
                }
            },
            editTemplate(_mode,_id){
                this.paramAddEditTemplate.mode =_mode
                this.paramAddEditTemplate.id= _id
                this.isModalAddEditActive = true
                // const dat = this.mytemplate.find( datTemplate => {
                //     return   datTemplate.id === id
                // })
                //
                // // assign to var before display
                // this.bufferTemplateName = dat.name
                // this.bufferTemplateContent = JSON.parse(JSON.stringify(dat.content))
                // // console.log( dat.content )
                // // change tab for display
                // this.displayPage(1)
            },
            deleteTemplate(_id){
                const  vm = this
                this.$buefy.dialog.confirm({
                    title: 'Deleting Template',
                    message: 'Are you sure you want to <b>delete</b> your Template? This action cannot be undone.',
                    confirmText: 'Delete Template',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                        const datTo ={
                            "id": _id
                        }
                        axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                        axios.post(`${getBaseURLforBackEnd()}/api/deletetemplatenonautomate`,datTo,getConfigAxios())
                            .then((res)=>{
                                if(res.status === 200){
                                    vm.$buefy.toast.open({
                                        message: `Data has benn delete `,
                                        type: 'is-success'
                                    })
                                    vm.loadMytemplate()
                                }
                            })
                            .catch((err)=>{
                                vm.$buefy.dialog.alert({
                                    title: 'Error',
                                    message: `${err}`,
                                    type: 'is-danger',
                                    hasIcon: true,
                                    icon: 'times-circle',
                                    iconPack: 'fa',
                                    ariaRole: 'alertdialog',
                                    ariaModal: true
                                })
                            })
                    }
                })
            },
            loadMytemplate(){
                getMyTemplate(this.user_id)
                    .then(res=>{
                        this.mytemplate = res.data
                    })
                    .catch(err=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })
            },
            close(){
                this.isComponentModalActive = false
                this.$emit('close')
            }
        }
    }
</script>

<style scoped>

</style>